import styled from "styled-components";
import { Pagination as MuiPagination } from "@mui/material";
import { colors } from "../pages/css components/Style";

const StyledPagination = styled(MuiPagination)`
  & .MuiPaginationItem-root {
    margin-top: 10px;
    color: ${colors.purple}!important;
    font-size: 15px;
    border: 1px solid ${colors.purple}!important;

    &:hover {
      background: #32bcad2e;
    }
  }

  & .Mui-selected {
    color: white !important;
    background-color: ${colors.purple}!important;
  }
`;

export default function Pagination(props) {
  return <StyledPagination variant="outlined" {...props} />;
}
